import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../api";

function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState(() => localStorage.getItem("uride_remembered_email") || "");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleLogin = async (event) => {
    event.preventDefault();
    setError(""); setSubmitting(true);
    try {
      const response = await api.post("/auth/login", { email, password });
      localStorage.setItem("uride_token", response.data.token);
      localStorage.setItem("uride_user", JSON.stringify(response.data.user));
      if (remember) localStorage.setItem("uride_remembered_email", email);
      else localStorage.removeItem("uride_remembered_email");
      navigate(response.data.user.role === "superadmin" ? "/superadmin" : ["company_user", "company_admin"].includes(response.data.user.role) ? "/company-user" : response.data.user.role === "staff" ? "/staff/dashboard" : "/dashboard");
    } catch (err) {
      setError(err.response?.data?.message || "Unable to sign in. Please try again.");
    } finally { setSubmitting(false); }
  };

  return <AuthLayout eyebrow="URIDE TOUR AND TRANSPORT PRIVATE LIMITED" title="Logistics services that keep you moving." copy="Sign in to manage your logistics bookings and move every delivery with confidence.">
    <form className="auth-form" onSubmit={handleLogin}>
      <h2>Sign in</h2><p className="auth-copy">Use your Uride account details to continue.</p>
      {error && <p className="auth-message error">{error}</p>}
      <label htmlFor="email">Email address or username</label><div className="auth-input"><span>✉</span><input id="email" type="text" autoComplete="username" placeholder="you@example.com or username" value={email} onChange={(event) => setEmail(event.target.value)} required /></div>
      <div className="auth-label-row"><label htmlFor="password">Password</label><a href="mailto:info@uride.in?subject=Password reset">Forgot password?</a></div>
      <div className="auth-input"><span>🔒</span><input id="password" type="password" autoComplete="current-password" placeholder="Enter your password" value={password} onChange={(event) => setPassword(event.target.value)} required /></div>
      <label className="auth-remember"><input type="checkbox" checked={remember} onChange={(event) => setRemember(event.target.checked)} /> Remember me</label>
      <button type="submit" disabled={submitting}>{submitting ? "Signing in…" : "Sign in"}</button>
    </form>
  </AuthLayout>;
}

export function AuthLayout({ eyebrow, title, copy, children }) {
  return <main className="auth-page"><header className="auth-nav"><Link to="/" className="auth-brand">URIDE</Link><Link to="/">← Back to home</Link></header><section className="auth-panel"><div className="auth-intro"><p className="auth-eyebrow">{eyebrow}</p><h1>{title}</h1><p>{copy}</p></div>{children}</section></main>;
}

export default LoginPage;
